import { Link } from "react-router-dom";
import { siteData, navigation } from "../data";
import { Facebook, Instagram, FileText } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col xl:grid xl:grid-cols-4 gap-12 mb-16">
          {/* Brand & Contact */}
          <div className="xl:col-span-1">
            <img src={siteData.logo} alt={siteData.name} className="h-16 md:h-10 w-auto md:w-full md:max-w-[350px] object-contain md:object-left mb-6" />
            <div className="space-y-4 text-gray-600">
              <p className="flex items-start">
                <span>{siteData.address}</span>
              </p>
              <p className="flex items-center">
                <a href={`tel:${siteData.phone.replace(/\s/g, "")}`} className="hover:text-primary transition-colors">{siteData.phone}</a>
              </p>
              <p className="flex items-center">
                <a href={`mailto:${siteData.email}`} className="hover:text-primary transition-colors">{siteData.email}</a>
              </p>
              <p className="text-sm">CVR: {siteData.cvr}</p>
            </div>
            <div className="pt-8">
              <img 
                src="https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/23a2bcb9-ab14-4629-9067-156fbcc1a234.png" 
                alt="Partner Logo" 
                className="h-10 w-auto object-contain"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:contents gap-12 border-t border-b border-gray-100 py-12 xl:border-0 xl:py-0">
            {/* Navigation - Menu */}
            <div>
              <h4 className="font-serif text-xl font-normal text-dark mb-6">Menu</h4>
              <ul className="space-y-3">
                {navigation.slice(0, 3).map((item) => (
                  <li key={item.name}>
                    <Link to={item.href} className="text-gray-600 hover:text-primary transition-colors">
                      {item.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/galleri" className="text-gray-600 hover:text-primary transition-colors">
                    Galleri
                  </Link>
                </li>
                <li>
                  <Link to="/kontakt" className="text-gray-600 hover:text-primary transition-colors">
                    Kontakt
                  </Link>
                </li>
              </ul>
            </div>

            {/* Navigation - Selskaber & Catering */}
            <div>
              <h4 className="font-serif text-xl font-normal text-dark mb-6">Selskaber & Catering</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/selskaber-og-events" className="text-gray-600 hover:text-primary transition-colors">
                    Selskaber og events
                  </Link>
                </li>
                <li>
                  <Link to="/takeaway-catering" className="text-gray-600 hover:text-primary transition-colors">
                    Take away & Catering
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-serif text-xl font-normal text-dark mb-6">Følg os & Info</h4>
            <div className="flex gap-4 mb-6">
              <a
                href={siteData.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-bg-light flex items-center justify-center hover:bg-primary hover:text-white transition-all"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={siteData.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-bg-light flex items-center justify-center hover:bg-primary hover:text-white transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <a
              href={siteData.smiley}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-bg-light hover:bg-gray-200 transition-colors text-sm"
            >
              <FileText className="w-4 h-4" />
              Egenkontrol rapport
            </a>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>© {new Date().getFullYear()} {siteData.company}. Alle rettigheder forbeholdes.</p>
          <div className="flex flex-wrap items-center gap-6">
            <a href="https://www.iubenda.com/privacy-policy/96987733" className="iubenda-white iubenda-noiframe iubenda-embed hover:text-primary transition-colors" title="Privatlivspolitik ">Privatlivspolitik</a>
            <a href="https://www.iubenda.com/privacy-policy/96987733/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed hover:text-primary transition-colors" title="Cookiepolitik ">Cookiepolitik</a>
            <span>Handelsbetingelser</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
